import { apiAction } from 'apa/actions'
import * as types from 'customers/actions/types'


export const add = (work) => (dispatch, getState) =>
  dispatch(apiAction({
    url: '/api/work/',
    method: 'POST',
    data: work,
    onSuccess: (work) => {
      const customer = getState().customers.customer
      customer.work_done.push(work)
      return {
        type: types.ADD_WORK,
        customer: customer
      }
    }
  }))

export const remove = (work) => (dispatch, getState) =>
  dispatch(apiAction({
    url: `/api/work/${work.id}/`,
    method: 'DELETE',
    onSuccess: () => {
      const customer = getState().customers.customer
      const workLogIndex = customer.work_done.findIndex(
        item => item.id === work.id
      )
      customer.work_done.splice(workLogIndex, 1)
      return {
        type: types.DELETE_WORK,
        customer: customer
      }
    }
  }))